<template lang='pug' src='./Profile.pug'></template>
<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver, localize } from "vee-validate"

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default{
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data(){
    return{
      name: '',
      email: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      visiblePasswordForm: false
    }
  },
  methods:{
    ...mapGetters(['isTokenSet']),
    ...mapActions(['editUser']),
    showPasswordForm(){
      this.visiblePasswordForm = !this.visiblePasswordForm
    },
    async submit(){
      const userData = JSON.parse(window.localStorage.getItem("user"))
      const userId = userData._id
      await this.editUser({
        '_id': userId,
        'name': this.name,
        'email': this.email
      })
    },
    async submitPass(){
      const userData = JSON.parse(window.localStorage.getItem("user"))
      const userId = userData._id
      await this.editUser({
        '_id': userId,
        'oldPassword': this.currentPassword,
        'password': this.newPassword
      })
    }
  },
  created(){
    const userData = JSON.parse(window.localStorage.getItem("user"))
    this.name = userData.name
    this.email = userData.email
  },

}
</script>
